import React from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import {
  ContainerRow,
  ContainerCategoryName,
  CategoryNameText,
  Checkbox,
} from './styles';

import CardsList from '../cards-list/index';

const ItemRow = (props) => {
  const {
    group,
    isClosedType,
    selectOrUnselectItem,
    selectedCategories,
  } = props;

  const isMerged = !!_.head(group).cardSortMergedCategory;

  return (
    <ContainerRow isMerged={isMerged} key={group[0].cardSortCategory.id}>
      <ContainerCategoryName>
        {isClosedType ? (
          <CategoryNameText>{group[0].cardSortCategory.name}</CategoryNameText>
        ) : (
          <Checkbox
            label={group[0].cardSortCategory.name}
            checked={_.includes(selectedCategories, _.head(group).cardSortCategory)}
            onChange={(e, data) => selectOrUnselectItem(_.head(group).cardSortCategory, data)}
          />
        )}
      </ContainerCategoryName>

      <CardsList group={group} />
    </ContainerRow>
  );
};

ItemRow.propTypes = {
  isClosedType: PropTypes.bool.isRequired,
  selectOrUnselectItem: PropTypes.func.isRequired,
  group: PropTypes.arrayOf(PropTypes.shape({
    cardSortCategory: PropTypes.shape({
      name: PropTypes.string,
      id: PropTypes.string,
    }),
    cardSortMergedCategory: PropTypes.shape({
      name: PropTypes.string,
      id: PropTypes.string,
    }),
  })).isRequired,
  selectedCategories: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
  })).isRequired,
};

export default ItemRow;
